// API keys for external developers (server routes/api-keys.ts). Account-admin
// for its own account; a super-admin can pass another account's id.

import { apiFetch } from './api';

export interface ApiKeyRow {
  id: string;
  name: string;
  prefix: string;
  scopes: string[];
  /** Null: every site of the account. */
  siteIds: string[] | null;
  expiresAt: string | null;
  createdAt: string;
  createdByName: string | null;
  lastUsedAt: string | null;
  lastUsedIp: string | null;
  revokedAt: string | null;
  status: 'active' | 'expired' | 'revoked';
  usage: { last24h: number; last30d: number; errors30d: number } | null;
}

export interface ApiKeysState {
  accountId: string;
  keys: ApiKeyRow[];
  scopes: Array<{ id: string; description: string }>;
  sites: Array<{ id: string; name: string; archivedAt: string | null }>;
}

export interface ApiKeyInput {
  name: string;
  scopes: string[];
  siteIds: string[] | null;
  expiresInDays?: 30 | 90 | 365 | null;
}

const base = '/api/admin/api-keys';
const q = (accountId?: string) => (accountId ? `?accountId=${encodeURIComponent(accountId)}` : '');

export const listApiKeys = (accountId?: string) => apiFetch<ApiKeysState>(`${base}${q(accountId)}`);

/** The secret comes back once, here, and never again. */
export const createApiKey = (input: ApiKeyInput, accountId?: string) =>
  apiFetch<{ key: ApiKeyRow; secret: string }>(`${base}${q(accountId)}`, { method: 'POST', body: JSON.stringify(input) });

export const updateApiKey = (id: string, patch: Partial<Omit<ApiKeyInput, 'expiresInDays'>>) =>
  apiFetch<{ key: ApiKeyRow }>(`${base}/${id}`, { method: 'PATCH', body: JSON.stringify(patch) });

export const revokeApiKey = (id: string) => apiFetch<{ key: ApiKeyRow }>(`${base}/${id}`, { method: 'DELETE' });
